module.exports = "https://static.wmbcdn.com/uniweb/images/3b929250322225f1f9e28f70d39936e3.svg";